import Regex from '../Regex'

export default class AlphaDash extends Regex {
  get ruleName () {
    return 'alphaDash'
  }

  passes () {
    return super.passes(/^[A-Za-zÀ-ÿ-]+$/)
  }
}
